import XHTTP from "services/api/xhttp";
import paths from "routes/paths";

class PedestrianStatisticsApi {
  static END_POINTS = {
    getGeneralStats: (type) =>
      paths?.api?.pedestrianStatistics?.[
        `data${type === "areas" ? "ByAreas" : "ByRadius"}`
      ]?.general,
    getDetailsStats: (type) =>
      paths?.api?.pedestrianStatistics?.[
        `data${type === "areas" ? "ByAreas" : "ByRadius"}`
      ]?.details,
    getDailyAttendanceStats: (type) =>
      paths?.api?.pedestrianStatistics?.[
        `data${type === "areas" ? "ByAreas" : "ByRadius"}`
      ]?.dailyAttendance,
    getQueueDetailsStats: () =>
      paths?.api?.pedestrianStatistics?.dataByAreas.queueDetailsStats,
    getQueueDailyAttendanceStats: () =>
      paths?.api?.pedestrianStatistics?.dataByAreas.queueDailyAttendance,
    getQueueDailyAttendanceMaxStats: () =>
      paths?.api?.pedestrianStatistics?.dataByAreas.queueDailyAttendanceMax,
    getQueueWaitingTimeStats: () =>
      paths?.api?.pedestrianStatistics?.dataByAreas.queueWaitingTime,
  };

  static getQueueWaitingTimeStats(filters) {
    return XHTTP(
      PedestrianStatisticsApi.END_POINTS.getQueueWaitingTimeStats(),
      {
        method: "post",
        body: JSON.stringify(filters),
        abortMultiple: false,
      }
    );
  }

  static getQueueDailyAttendanceStats(filters) {
    return XHTTP(
      PedestrianStatisticsApi.END_POINTS.getQueueDailyAttendanceStats(),
      {
        method: "post",
        body: JSON.stringify(filters),
        abortMultiple: false,
      }
    );
  }

  static getQueueDailyAttendanceMaxStats(filters) {
    return XHTTP(
      PedestrianStatisticsApi.END_POINTS.getQueueDailyAttendanceMaxStats(),
      {
        method: "post",
        body: JSON.stringify(filters),
        abortMultiple: false,
      }
    );
  }

  static getQueueDetailsStats(filters) {
    return XHTTP(PedestrianStatisticsApi.END_POINTS.getQueueDetailsStats(), {
      method: "post",
      body: JSON.stringify(filters),
    });
  }

  static getGeneralStats(type, filters) {
    return XHTTP(PedestrianStatisticsApi.END_POINTS.getGeneralStats(type), {
      method: "post",
      body: JSON.stringify(filters),
    });
  }

  static getDetailsStats(type, filters) {
    return XHTTP(PedestrianStatisticsApi.END_POINTS.getDetailsStats(type), {
      method: "post",
      body: JSON.stringify(filters),
    });
  }

  static getDailyAttendanceStats(type, filters) {
    return XHTTP(
      PedestrianStatisticsApi.END_POINTS.getDailyAttendanceStats(type),
      {
        method: "post",
        body: JSON.stringify(filters),
      }
    );
  }
}

export default PedestrianStatisticsApi;
